import { Component, OnInit, Input } from '@angular/core';
import { CompanyService } from 'app/company/services/company.service';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';
import { Result } from 'app/core/models/result';
import { CompanyAuditTypeListModel } from 'app/company/models/company-audit-type-list.model';

@Component({
    selector: 'app-company-audit-type-list',
    templateUrl: './company-audit-type-list.component.html',
    styleUrls: ['./company-audit-type-list.component.css']
})
export class CompanyAuditTypeListComponent implements OnInit {
    errors: string[];
    auditTypes: CompanyAuditTypeListModel[];
    @Input() companyId: string;
    selectedAuditTypeId: number;
    companyDetailsModel: CompanyDetailsModel;

    constructor(
        private companyService: CompanyService
    ) {
    }

    ngOnInit() {
        this.loadAuditTypes();
    }

    loadAuditTypes(): void {
        this.companyService.getCompanyAuditTypes(this.companyId).subscribe(
            audits => {
                this.auditTypes = audits;
            },
            error => this.errors = error.errorList
        );
    }

    deleteCompanyAuditType(): void {
        this.companyService.deleteCompanyAuditType(this.companyId, this.selectedAuditTypeId).subscribe(
            result => this.loadAuditTypes(),
            error => this.errors = (<Result>error).errorList
        );
    }

    onCompanyAuditTypeAdded($event): void {
        this.loadAuditTypes();
    }
}
